import api from '@/lib/api'

export default {
  async getAnnouncements ({ dispatch }, { page = 1, size = 10 }) {
    try {
      return await api.getAnnouncementsAPI(page, size)
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },

  async getAnnouncement ({ dispatch }, id) {
    try {
      return await api.getAnnouncementAPI(id)
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },

  async createAnnouncement ({ dispatch }, data) {
    try {
      const { success, message } = await api.createAnnouncementAPI(data)
      dispatch('addTemporalNotification', { type: 'success', message })
      return success
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },

  async updateAnnouncement ({ dispatch }, { id, data }) {
    try {
      const { success, message } = await api.updateAnnouncementAPI(id, data)
      dispatch('addTemporalNotification', { type: 'success', message })
      return success
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },

  async toggleAnnouncementStatus ({ dispatch }, id) {
    try {
      const { success, message } = await api.toggleAnnouncementStatusAPI(id)
      dispatch('addTemporalNotification', { type: 'success', message })
      return success
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },

  async getAnnouncementStats ({ dispatch }, id) {
    try {
      return await api.getAnnouncementStatsAPI(id)
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  },

  async removeAnnouncement ({ dispatch }, id) {
    try {
      const { success, message } = await api.deleteAnnouncementAPI(id)
      dispatch('addTemporalNotification', { type: 'success', message })
      return success
    } catch (error) {
      dispatch('addTemporalNotification', { type: 'danger', message: error.message })
      return false
    }
  }
}
